angular.module('CarsSaraBo').factory('SpecialOfferGAConfig', ['GAService', function (gaService) {
	return {
		moderateGa: function () {
			var category = "Autos_moderacion";
			var mapInfo = {
				"Aprobar_promocion": function (eventName, specialOffer, view) {
					gaService.notify(category, eventName, [specialOffer.companyName, specialOffer.name, view])
				},
				"Intencion_rechazar_promocion": function (eventName, specialOffer, view) {
					gaService.notify(category, eventName, [specialOffer.companyName, specialOffer.name, view])
				},
				"Rechazar_promocion": function (eventName, specialOffer, view) {
					gaService.notify(category, eventName, [specialOffer.companyName, specialOffer.name, view])
				},
				"Listado_moderación_ver_detalle": function (eventName, specialOffer) {
					gaService.notify(category, eventName, [specialOffer.companyName, specialOffer.name])
				},
				"Listado_moderación_ocultar_detalle": function (eventName, specialOffer) {
					gaService.notify(category, eventName, [specialOffer.companyName, specialOffer.name])
				},
				"Filtrar": function (eventName, filter) {
					gaService.notify(category, eventName, [filter])
				}
			}
			return {
				send: function (eventName, param1, param2) {
					mapInfo[eventName].call(mapInfo, eventName, param1, param2);
				}
			}
		}
	}
}]);



//////////////////
// WEBPACK FOOTER
// ./public/app/models/special_offer_ga_config_service.js
// module id = 866
// module chunks = 3